import { pipelinesAPI } from '../../api/kanban';

export const state = {
  pipelines: [],
  currentPipelineId: null,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getPipelines(_state) {
    return _state.pipelines;
  },
  getCurrentPipelineId(_state) {
    return _state.currentPipelineId;
  },
  getCurrentPipeline(_state) {
    if (!_state.pipelines.length) return null;
    if (!_state.currentPipelineId) return _state.pipelines[0];
    return _state.pipelines.find(p => p.id === Number(_state.currentPipelineId)) || _state.pipelines[0];
  },
  getPipelineById: _state => id => {
    return _state.pipelines.find(p => p.id === Number(id));
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  getPipelines: async function getPipelines({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await pipelinesAPI.get();
      const pipelines = response.data || [];
      commit('SET_PIPELINES', pipelines);
      return pipelines;
    } catch (error) {
      // Ignora erro ou propaga
      return [];
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  fetchPipelines: async function fetchPipelines(context) {
    return context.dispatch('getPipelines');
  },

  createPipeline: async function createPipeline({ commit }, payload) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await pipelinesAPI.create(payload);
      const newPipeline = response.data;
      commit('ADD_PIPELINE', newPipeline);
      return newPipeline;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  updatePipeline: async function updatePipeline({ commit }, { id, ...payload }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await pipelinesAPI.update(id, payload);
      const updated = response.data;
      commit('EDIT_PIPELINE', updated);
      return updated;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  deletePipeline: async function deletePipeline({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await pipelinesAPI.delete(id);
      commit('DELETE_PIPELINE', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  setCurrentPipelineId({ commit }, id) {
    commit('SET_CURRENT_PIPELINE_ID', id);
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  SET_PIPELINES(_state, pipelines) {
    _state.pipelines = pipelines;
  },
  ADD_PIPELINE(_state, pipeline) {
    _state.pipelines.push(pipeline);
  },
  EDIT_PIPELINE(_state, updated) {
    const index = _state.pipelines.findIndex(p => p.id === updated.id);
    if (index !== -1) {
      _state.pipelines.splice(index, 1, updated);
    }
  },
  DELETE_PIPELINE(_state, id) {
    _state.pipelines = _state.pipelines.filter(p => p.id !== Number(id));
    if (_state.currentPipelineId === Number(id)) {
      _state.currentPipelineId = _state.pipelines[0]?.id || null;
    }
  },
  SET_CURRENT_PIPELINE_ID(_state, id) {
    _state.currentPipelineId = id ? Number(id) : null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
